import space from '../namespace';
import defaultState, { IState } from '../state';
import actionTypes, { IAction, ActionTypeValues } from '../actionTypes';

const reducer = (
  state: IState,
  action: IAction<
    Partial<IState[space.app]> & {
      namespace?: `${space}`;
      resetKeys?: string[];
    }
  >,
): IState => {
  const { type, namespace = space.app, payload } = action;

  switch (type) {

    case actionTypes[namespace][ActionTypeValues.RESET_PAGE_STATE]: {
      const { namespace: resetNameSpace = space.home, resetKeys = [] } = payload || {};
      const resetValues = resetKeys.reduce((prev, cur) => {
        const defaultValue = defaultState()[resetNameSpace] as any;
        return defaultValue
          ? { ...prev, [cur]: defaultValue[cur] }
          : { ...prev };
      }, {});
      return {
        ...state,
        [resetNameSpace]: {
          ...state[resetNameSpace],
          ...resetValues,
        },
      };
    }

    case actionTypes[namespace][ActionTypeValues.UPDATE_ACCOUNT]: {
      const _state = state[namespace];
      return {
        ...state,
        [namespace]: {
          ..._state,
          account: payload,
        }
      }
    }

    case actionTypes[namespace][ActionTypeValues.CLEAR_ACCOUNT]: {
      const _state = state[namespace];
      return {
        ...state,
        [namespace]: {
          ..._state,
          account: undefined,
        }
      }
    }

    case actionTypes[namespace][ActionTypeValues.UPDATE_APP_SENSORS]: {
      const _state = state[namespace];
      return {
        ...state,
        [namespace]: {
          ..._state,
          sensors: payload,
        }
      }
    }

    case actionTypes[namespace][ActionTypeValues.UPDATE_PERMISSION]: {
      const _state = state[namespace];
      return {
        ...state,
        [namespace]: {
          ..._state,
          permission: payload,
        }
      }
    }

    default:
      return state;
  }
};

export default reducer;
